import React, { Component } from 'react';
import Table from '../../tables/Table';
import { orderBy, filter, get, identity } from 'lodash';
import { LIST_VIEW_HEADERS } from '../../../constants/settings';
import { toDisplayString, isUnlimited, isZero, dateToWeekdayShort, msToHour } from '../../../lib/date.utils';
import HighlightRow from '../../tables/HighlightRow';
import { ADMIN_LIST_VIEW_HEADERS } from '../../../constants/admin/settings';
import SelectRow from '../../tables/SelectRow';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { requireUseUntil } from '../../../selectors/admin/models/lineup';

const _SMALL_COLUMNS = ['linearStates.linearUseUntil'];
const _LARGE_COLUMNS = ['date', 'liveStates.liveStateComment'];

class ListView extends Component {
    _transformFields = {
        'clearing.live': (s = 'hidden') => (
            <span className={`u-truncate ckp-timetable-clearing-inline is-${s.toLowerCase().replace(/_/g, '-')}`}>
                {s.toUpperCase() === 'HIDDEN' ? '' : s.replace(/_/g, ' ').toUpperCase()}
            </span>
        ),
        'clearing.nonLinear': (s = 'hidden') => (
            <span className={`u-truncate ckp-timetable-clearing-inline is-${s.toLowerCase().replace(/_/g, '-')}`}>
                {s.toUpperCase() === 'HIDDEN' ? '' : s.replace(/_/g, ' ').toUpperCase()}
            </span>
        ),
        'clearing.useUntil': (d, data) => {
            return requireUseUntil(data.clearing && data.clearing.nonLinear)
                ? (d && `${isZero(d) ? '' : isUnlimited(d) ? 'Unlimited' : toDisplayString(d)}`) || ''
                : '';
        },
        date: (_, data) =>
            `${dateToWeekdayShort(data.stageDate)} ${toDisplayString(data.stageDate)} ${msToHour(
                data.start
            )} - ${msToHour(data.end)}`,
    };
    _changeSort = (field) => {
        this.props.setFilter('sortBy', field);
        this.props.setFilter('order', this.props.sortBy === field && this.props.order === 'asc' ? 'desc' : 'asc');
    };
    _filterEntry = (e) => {
        let okay = true;
        const { artistsFilters, nonLinearFilters, stagesFilters, liveFilters } = this.props;
        okay = okay && (artistsFilters && artistsFilters.length ? artistsFilters.includes(e.artistName) : true);
        okay = okay && (stagesFilters && stagesFilters.length ? stagesFilters.includes(e.stageName) : true);
        okay =
            okay &&
            (liveFilters && liveFilters.length
                ? liveFilters.includes((get(e, 'clearing.live') || '').toLowerCase())
                : true);
        okay =
            okay &&
            (nonLinearFilters && nonLinearFilters.length
                ? nonLinearFilters.includes((get(e, 'clearing.nonLinear') || '').toLowerCase())
                : true);
        return okay;
    };
    _orderAndFilterEntries = () =>
        orderBy(
            filter(this.props.entries, this._filterEntry),
            this.props.sortBy === 'date'
                ? (d) => `${toDisplayString(d.stageDate)} ${d.start} - ${d.end}`
                : this.props.sortBy,
            this.props.order
        );
    _highlight = () => '';
    _enableRow = () => this.props.isAdmin && hasPermissions(this.props.user, PERMISSIONS.EVENT_EDIT);
    _isSelected = (item) => (this.props.selectedEntries || []).includes(item.id);
    render() {
        return (
            <React.Fragment>
                <Table
                    selectAllChecked={this.props.selectAllChecked}
                    enableSelectFunction={identity}
                    selectAll={this.props.selectAll}
                    isSelected={this._isSelected}
                    onSelect={this.props.onSelect}
                    enableRowFunction={this._enableRow}
                    disableTooltip={true}
                    RowComponent={this.props.isAdmin ? SelectRow : HighlightRow}
                    highlightFunction={this._highlight}
                    sort={this.props.sortBy}
                    changeSort={this._changeSort}
                    sortDirection={this.props.order}
                    smallColumns={_SMALL_COLUMNS}
                    largeColumns={_LARGE_COLUMNS}
                    transformFunctions={this._transformFields}
                    canOpenRows={true}
                    noSelect={this.props.noSelect}
                    onOpen={this.props.showEntry}
                    headers={this.props.isAdmin ? ADMIN_LIST_VIEW_HEADERS : LIST_VIEW_HEADERS}
                    data={this._orderAndFilterEntries()}
                />
            </React.Fragment>
        );
    }
}

export default ListView;



// WEBPACK FOOTER //
// ./src/components/application/timetable/ListView.js